import { Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup, Validators } from '@angular/forms';
import { FormComponentLookup } from '@ptl/forms';
import { PrePopulatedDataStateStructure } from 'src/app/angular-elements/shared/components/configs/interfaces/prePopulatedDataStateStructure.interface';
import { IndividualMarketPersonsComponent } from '../individual-market-persons.component';
import { environment } from 'src/environments/environment';
import {Person} from '../interfaces/person.interface';

@FormComponentLookup('subscriber-person')
@Component({
    selector: 'app-individual',
    templateUrl: './../individual-market-persons.component.html',
    styleUrls: ['./../individual-market-persons.component.scss'],
    standalone: false
})
export class IndividualComponent extends IndividualMarketPersonsComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.applicantType = 'Your';
    this.allowRemoval = false;


    /** Should have at least 1 subscriber item present */
    if ((this.personsForm.get('persons') as UntypedFormArray).length === 0) {
      (this.personsForm.get('persons') as UntypedFormArray).push(
        this.newPersonData()
      );
    }

  }


  newPersonData(
    /*dob: string = null,
    gender: string = null,
    tobaccoIndicator: boolean = null,
    firstName: string = null,
    middleInitial: string = null,
    lastName: string = null,
    suffix: string = null,
    ssn: string = null,
    noSSN: string = null,
    sameAddressAsSubscriber: boolean = null,
    addressLine1: string = null,
    addressLine2: string = null,
    city: string = null,
    state: string = null,
    zipCode: string = null,
    county: string = null,

    homePhoneNumber: string = null,
    workPhoneNumber: string = null,
    mobilePhoneNumber: string = null,
    email: string = null,
    languageSpoken: string = null,
    languageRead: string = null,
    specialAssistance: boolean = null,

    mailingAddressLine1: string = null,
    mailingAddressLine2: string = null,
    mailingCity: string = null,
    mailingState: string = null,
    mailingZipCode: string = null,
    sameMailingAddress: boolean = null*/
    person: Person = {} as Person

  ): UntypedFormGroup {

    const prePopulateData: PrePopulatedDataStateStructure = this.reducerUtilityService.getComponentStates().PrePopulateData;

    if (prePopulateData.prepopulatedFields?.dob?.length > 0) {
      person.dob = this.dateService.getDateAsMoment(prePopulateData.prepopulatedFields.dob).add(8, 'hours').toISOString();
    }

    if (prePopulateData.prepopulatedFields?.gender?.length > 0) {
      person.gender = prePopulateData.prepopulatedFields.gender === 'F' ? 'F' : 'M';
    }

    const group = this.fb.group({
      dob: this.fb.control(person.dob || null, this.dobValidators().concat(Validators.required)),
      gender: this.fb.control(person.gender || null, [Validators.required]),
      tobaccoIndicator: this.fb.control(person.tobaccoIndicator || false)
    });
    Object.keys(person).filter(key => (person[key] !== null && person[key] !== undefined && !['dob', 'gender', 'tobaccoIndicator'].includes(key)))
      .forEach(key => group?.addControl(key, this.fb.control(person[key], null)));
    return group;
  }
}
